import { useStore } from 'effector-react'
import { $sorting, nextSort } from 'features/cars-list/model'
import { Sorting } from 'features/cars-list/types'
import { createMediaStyles } from 'lib/styled-helpers'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon } from 'ui/icon'
import { EcomIconsId } from 'ui/icon/types'

import { getProjectName } from '../../../lib/get-project-name'
import { useAVNConfig } from '../../../stages/AVN'

type Props = Sorting

export const Sort: FC<Props> = ({ text, options }) => {
  const sorting = useStore($sorting)

  return (
    <Wrapper>
      <span>{text}</span>
      {options.length &&
        !!sorting &&
        options.map((option) => {
          let iconName: EcomIconsId = 'sort-asc'
          if (option.key === sorting.sort) {
            iconName = sorting.order === 'asc' ? 'sort-asc' : 'sort-desc'
          }

          return (
            <SortOption key={option.key} active={option.key === sorting.sort} onClick={() => nextSort(option.key)}>
              <span>{option.label}</span>
              <IconWrapper>
                <Icon name={iconName} size={0.75} />
              </IconWrapper>
            </SortOption>
          )
        })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 2.1rem 1.6rem;
  ${({ theme }) => theme.textStyles.p2};
  background: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.grey[500]};
  border-radius: ${() => getProjectName() === 'avito' && '12px'};

  ${createMediaStyles(() => ({
    tablet: `border-top: 0; justify-content: flex-start;`
  }))}
`

const SortOption = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  margin-left: ${({ theme }) => theme.spacing[3]};
  color: ${({ active, theme }) => (active ? theme.palette.brand.primary : theme.palette.grey[500])};

  &:hover {
    cursor: pointer;
  }
`

const IconWrapper = styled.span`
  line-height: 1;
  margin-left: ${({ theme }) => theme.spacing[1]};
  padding-top: ${({ theme }) => theme.spacing[1]};
`
